export const FONTLIST = [
    "Serif",
    "Monospace",
    "Verdana",
    "Impact",
];

export const DEFAULT_TEXT = {
    type: "text",
    fontFamily: FONTLIST[0],
    fontSize: 30,
    justify: "center",
    x: 250,
    y: 250,
    angle: 0,
    size: 450,
    text: "Enter text",
    zIndex: 99999,
};
